export default "__VITE_ASSET__36fdd474__"